import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';

import { IParcel } from '../interfaces';
import { ParcelMapper } from '../mappers';

export type IGetParcelsRepoResponse = IRepoResponse<200, IParcel[]> | IRepoResponse<400 | 500, string>;

export type IGetParcelsRepo = IRepo<[any], IGetParcelsRepoResponse>;

export const GetParcelsRepoType = Symbol.for('GetParcelsRepo');

@bind(GetParcelsRepoType)
export class GetParcelsRepo implements IGetParcelsRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query: object) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/boxes/options', query) });

      if (result.status === 200) {
        const data: IParcel[] = result.data.map((user) => ParcelMapper.toDomain(user));

        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
